// extracted by mini-css-extract-plugin
module.exports = {"rangeValues":"dual-slider-component_rangeValues__ZGHoK"};